var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "key",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.396,
    height: 14.396,
    viewBox: "0 0 14.396 14.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M14.4.421A.422.422,0,0,0,13.974,0H11.588a.422.422,0,0,0-.3.124L6.066,5.347A4.64,4.64,0,1,0,9.049,8.33l.361-.361L10.776,7.7a.422.422,0,0,0,.331-.331l.243-1.216,1.216-.243a.422.422,0,0,0,.331-.331l.231-1.16h.847a.422.422,0,0,0,.422-.422V.422Zm-.844,3.151h-.771a.422.422,0,0,0-.414.34l-.243,1.223-1.215.243a.422.422,0,0,0-.331.331l-.243,1.216-1.216.243a.422.422,0,0,0-.216.115l-.64.64a.422.422,0,0,0-.095.452A3.8,3.8,0,1,1,6.022,6.227a.422.422,0,0,0,.452-.095L11.763.844h1.193L7.71,6.089a.422.422,0,1,0,.6.6L13.552,1.44Z",
    transform: "translate(0)",
    fill: "#666"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(2.18 9.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M79.689,344.87a1.265,1.265,0,1,0,0,1.79A1.267,1.267,0,0,0,79.689,344.87Zm-.6,1.193a.422.422,0,1,1,0-.6A.422.422,0,0,1,79.092,346.063Z",
    transform: "translate(-77.529 -344.5)",
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPassword);
export default __webpack_public_path__ + "static/media/icn_password.21a5b44c.svg";
export { ForwardRef as ReactComponent };